// Globals
import { useTranslation } from 'react-i18next';

// Store
import { useAppDispatch } from '@/store';
import { updateSettlementData } from '../../feature';

// Components
import { Spinner } from '@/ui';
import { StyledContainer, StyledTitle } from '../../components';
import SettlementForm from '../../components/SettlementForm/SettlementForm';
import SettlementCard from '../../components/SettlementCard/SettlementCard';

// Helpers
import { TSettlementFormValues } from '../../helpers';
import { useGetSettlementData } from '../../hooks';
import { useBoolean } from '@/hooks';

const SettlementDataContainer = () => {
  const { t } = useTranslation('prices');
  const { value: isEditing, setFalse: finishEditing, setTrue: startEditing } = useBoolean();

  const { isLoading, data } = useGetSettlementData();
  const dispatch = useAppDispatch();

  const handleSubmit = async (values: TSettlementFormValues) => {
    try {
      await dispatch(
        updateSettlementData({
          ...values,
        }),
      ).unwrap();
      finishEditing();
    } catch (error) {}
  };

  return (
    <StyledContainer>
      <StyledTitle>{t('title_settlement')}</StyledTitle>

      <Spinner spinning={isLoading}>
        {!isEditing ? (
          <SettlementCard data={data} onEdit={startEditing} />
        ) : (
          <SettlementForm initialValues={data ?? undefined} onSubmit={handleSubmit} />
        )}
      </Spinner>
    </StyledContainer>
  );
};

export default SettlementDataContainer;
